<contract-select barsClass="block w-1/2 ml-[25%]" [updateCostCenterNotifier$]="updateCostCenterFormCtrl$" />
